import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { ShowsApi } from '../../../network';
import { ShowAdminModel } from '../../../network/rest';
import ApiErrorHandler from '../../../utils/ApiErrorHandler';
import { translations } from '../../../utils/staticContent';
import ImageUploadForm from '../../components/ImageUploadForm';

export default function ShowsForm({ show }: { show?: ShowAdminModel }) {
    const [title, setTitle] = useState(show?.title || '');
    const [type, setType] = useState(show?.type || '');
    const [fileId, setFileId] = useState('');

    const [error, setError] = useState('');
    return (
        <div className="ShowsForm">
            <Container component="main" maxWidth="md">
                <Grid
                    container
                    component="form"
                    rowSpacing={2}
                    columnSpacing={{ xs: 1, sm: 2 }}
                    noValidate
                    mt={1}
                    onSubmit={async (e) => {
                        e.preventDefault();

                        try {
                            if (show) {
                                await ShowsApi.updateShowApiV1ShowsShowPut({
                                    id: show.id,
                                    bodyUpdateShowApiV1ShowsShowPut: {
                                        title,
                                        type,
                                    },
                                });
                            } else {
                                await ShowsApi.createShowApiV1ShowsShowPost({
                                    showCreateModel: {
                                        title,
                                        type,
                                        fileId,
                                    },
                                });
                                setTitle('');
                                setType('');
                            }
                        } catch (e) {
                            const error = ApiErrorHandler(e);
                            setError(error);
                        }
                    }}
                >
                    <Grid item xs={12} sm={6}>
                        <TextField
                            required
                            fullWidth
                            id="title"
                            label={translations.title}
                            name="title"
                            autoFocus
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            required
                            fullWidth
                            name="type"
                            label={translations.type}
                            id="type"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                        />
                    </Grid>
                    <ImageUploadForm setError={setError} fileId={fileId} setFileId={setFileId} />
                    <Grid item xs={12} sm={12}>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            disabled={
                                title.length < 2 ||
                                title.length > 30 ||
                                type.length > 30 ||
                                type.length < 2
                            }
                        >
                            {translations.save}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Typography component="span" color="red">
                            {error}
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}
